import { render, staticRenderFns } from "./orderRefundSure.vue?vue&type=template&id=408ba805&scoped=true"
import script from "./orderRefundSure.vue?vue&type=script&lang=js"
export * from "./orderRefundSure.vue?vue&type=script&lang=js"
import style0 from "./orderRefundSure.vue?vue&type=style&index=0&id=408ba805&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ba805",
  null
  
)

export default component.exports